// 認証モーダル
const ModalAuth = {
  namespaced: true,

  state: {
    modal: false,
    type: '', // b_delete of all_b_delete
    item: {},
  },
  getters: {
    getModal: state => {
      return state.modal
    },
    getType: state => {
      return state.type
    },
    getItem: state => {
      return state.item
    },
  },
  mutations: {
    setModal(state, modal) {
      state.modal = modal
    },
    setType(state, type) {
      state.type = type
    },
    setItem(state, item) {
      state.item = item
    },
  },
  actions: {
    reset({ commit }) {
      commit('setType', '')
      commit('setItem', {})
    },
  },
}

export default ModalAuth
